// @ts-nocheck
import 'pdfjs-viewer-element';

function base64PDFToBlobUrl( base64: string ) {
  const binStr = atob( base64 );
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[ i ] = binStr.charCodeAt( i );
  }
  const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
  const url = URL.createObjectURL( blob );
  return url;
}

export function PdfJs(props: {content:string}) {
    const { content } = props 
    const url = content ? base64PDFToBlobUrl( content ) : undefined
  return (
    <div
      id="pdf"
      style={{
        padding: 12,
        paddingRight: 24,
        width: '70vw',
        height: '89vh',
        overflowY: 'auto',
        overflowX: 'auto',
      }}
    >
      <pdfjs-viewer-element
        src={url}
        zoom="auto"
        viewer-path="./pdfjs-4.5.136-dist"
        viewer-extra-styles="#download { display: none } #print { display: none } #editorFreeText { display: none } #editorStamp { display: none } #editorInk { display: none }"
      ></pdfjs-viewer-element>
    </div>

  )
}